"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeZoneNameById = exports.guessTimeZone = exports.filterTimeZone = void 0;
var timeZone_1 = require("../constants/timeZone");
var moment = require("moment-timezone");
function filterTimeZone(timeZoneId) {
  return timeZone_1.timeZones.find(function (timeZoneItem) {
    return timeZoneItem.id === timeZoneId;
  });
}
exports.filterTimeZone = filterTimeZone;
function guessTimeZone() {
  var guess = moment.tz.guess();
  var isSupported = timeZone_1.timeZones.some(function (timeZone) {
    return timeZone.name === guess;
  });
  if (isSupported) {
    return guess;
  }
  return filterTimeZone(timeZone_1.DEFAULT_TIMEZONE_ID).name;
}
exports.guessTimeZone = guessTimeZone;
function getTimeZoneNameById(timeZoneId) {
  if (timeZoneId) {
    var timeZone = filterTimeZone(timeZoneId);
    if (timeZone) {
      return timeZone.name;
    }
  }
  return guessTimeZone();
}
exports.getTimeZoneNameById = getTimeZoneNameById;